module.exports = __webpack_public_path__ + "img/exit.bfe22dd0.svg";